'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dot = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dot = exports.Dot = (0, _components2.default)({
  is: 'button',
  m: 0,
  p: 0,
  size: 16,
  bg: 'darken',
  borderRadius: 99999,
  border: 4,
  borderColor: 'transparent'
}, {
  appearance: 'none',
  backgroundClip: 'padding-box'
}, 'size', 'borderRadius', 'borders', 'borderColor', 'space', 'color');

Dot.displayName = 'Dot';

exports.default = Dot;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rebass/dist/Dot.js
// module id = 125
// module chunks = 4